<template>
    <div class="position">
      <div class="container">
        <div class="companyInfo">
        <ul class="ui-list ui-company">
          <li class="ui-border-t">
            <div class="positionInfo">
              <span><b>{{ jobName }}</b></span><span class="pay"><b>{{ salary }}</b></span>
            </div>
            <div class="edu"><span class="yearImg"></span><span class="yearTxt">{{ jobLifeRequire }}</span>
            <span class="eduImg"></span><span class="eduTxt">{{ educationRequire }}</span>
            </div>
            <div class="temptation" v-show='treatment.length > 0'><span>职位诱惑：{{ treatment }}</span></div>
          </li>
          <li>
            <div class="companyHead">
              <!--<span style="background-image:url(http://placeholder.qiniudn.com/80x80)"></span>-->
              <img :src="enterpriseLogo" />
            </div>
            <div class="ui-list-info company-info">
              <div class="ui-company-title">
                <span class="company-name"><b>{{ enterpriseName }}</b></span>
              </div>
              <div class="company-type">
                <span >{{ industry +'/'+ level + '/' + count }}</span>
              </div>
              <div class="company-address">
                <span >{{ address }}</span>
              </div>
            </div>
          </li>
        </ul>
       </div>

       <div class="positionDetail">
         <ul class="ui-list ui-detail">
           <li><div>
             <span class="positionImg"></span><span class="positionTxt">职位描述</span>
             </div></li>
           <li><div class="position-detail" v-html="jobDescrip"></div></li>
         </ul>
       </div>
      </div>
        <!--悬浮在底部的按钮-->
      <div class="btn-pos" @click="goResume">
        <span>去填写简历</span>
      </div>
    </div>
</template>

<script>
import api from '@/script/util'
import '@/style/frozen.css'
import '@/style/base.css'
export default {
  name: '', // 职位详情
  data () {
    return {
      jobName: '',
      salary: '',
      jobLifeRequire: '',
      educationRequire: '',
      enterpriseLogo: './static/image/companyHead.png',
      enterpriseName: '',
      industry: '',
      level: '',
      count: '',
      address: '',
      treatment: [],
      email: '',
      jobDescrip: ''
    }
  },
  created: function () {
    document.title = '职位详情'
    let jobLifeRequire = ['不限', '一年以下', '1-3年', '3-5年', '5年以上']
    let salary = ['面议', '3-5k', '5-10k', '10-20k', '20-30k', '30k以上']
    let level = ['未融资', '天使轮', 'A轮', 'B轮', 'C轮', 'C轮以上', '上市公司']
    let educationRequire = ['不限', '大专', '本科', '硕士', '博士']
    let count = ['50人以下', '50-200人', '200-500人', '500人以上']
    let params = {
      id: api.getVal('id') // '4570fa3c-4f4e-11e7-ac9b-ecf4bbbefbd4'
    }
    api.GetPosition(params)
      .then(res => {
        console.log(res)
        this.jobName = res.jobName
        this.salary = salary[res.salary]
        this.jobLifeRequire = jobLifeRequire[res.jobLifeRequire]
        this.educationRequire = educationRequire[res.educationRequire]
        this.enterpriseLogo = res.orgLogo ? res.orgLogo : this.enterpriseLogo
        this.enterpriseName = res.orgName
        this.industry = res.industry
        this.level = level[res.level]
        this.count = count[res.count]
        this.address = res.address
        this.jobDescrip = res.jobDescrip
        this.treatment = this.GetTreatment(res.treatmentList)
        this.email = res.email
      })
  },
  methods: {
    GetTreatment (array) {
      let treatment = ''
      array.forEach(function (e) {
        treatment += e.welfareTreatment + '，'
      }, this)
      return treatment.substring(0, treatment.length - 1)
    },
    goResume () {
      this.$router.push({
        name: '投递简历',
        params: {
          id: api.getVal('id'),
          companyEmail: this.email,
          recommendId: api.getVal('recommendId'),
          subId: api.getVal('subId')
        }
      })
    }
  }
}
</script>


<style scoped>
.position{
  display: flex;
  flex-direction: column;
  height: 100%;
}
.container{
  flex:1;
  overflow: auto;
}
a{
  text-decoration: none;
  color:#333333;
}
 .ui-company li,.ui-detail li{
   margin:0 1em !important
 }
 .ui-company li:first-child{
   /*height: 6.2em;*/
   padding: 0.8em 0 0.75em 0;
   border-bottom:1px solid #e0e0e0 !important;
   display:flex;
   flex-direction:column;
}
.edu{
  height:1.07em;
  padding-top:.8em;
}
 .positionInfo {
   /*padding:.8em 0*/
 }
 .pay{
   padding-left:.95em;
   color:#ff6e0b;
 }
 .yearImg{
   display:inline-block;
   background:url('../assets/image/years.png') no-repeat;
   background-size:1.06666em 1.06666em;
   width:1em;
   height: 1em;
   padding-right:.25em;
   vertical-align:top;
 }
 .yearTxt{
   vertical-align: top;
   height: 1.07em;
   padding-right:1.7em;
   font-size:.8em;
 }
 .eduImg{
   display:inline-block;
   background:url('../assets/image/education.png') no-repeat;
   background-size:1.06666em 1.06666em;
   width:1em;
   height:1em;
   padding-right:.25em;
   vertical-align:top;
 }
 .eduTxt{
    vertical-align: top;
    height: 1.07em;
    font-size:.8em;
 }
 .temptation{
   color:#aaaaaa;
   font-size:.8em;
   padding-top:.4em;
 }

 .ui-company li:nth-child(2){
   /*height:5.67em;*/
   -webkit-box-align:center;
 }
  .companyHead{
    padding-right:1em;
  }
 .companyHead img{
   width:2.6667em;
   height:2.6667em;
   border-radius:100%;
 }
 .company-info{display:block;}
 .company-type,.company-address{
   color:#aaaaaa;
   font-size:0.8em;
 }
 .positionDetail{
   margin-top:.5334em
 }
 .ui-detail li:first-child{
   height:3em;
   border-bottom:1px solid #e0e0e0;
   -webkit-box-align:center;
 }
 .positionImg{
   display:inline-block;
   background:url('../assets/image/position.png') no-repeat;
   background-size:1.06666em 1.06666em;
   width:1em;
   height:1em;
   padding-right:.3334em;
   vertical-align: text-top;
 }
 .position-detail{
   margin:.8em 0 0;
   width:100%;
   line-height:1.8em;
 }
 .position-detail p{
   padding-top:1em
 }
 .position-detail img{
   width:100%;
   border-radius:.15em
 }
 .btn-pos{
    margin-top:.5334em;
    height: 2.2rem;
    background-color: #ffc001;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:1.2em;
 }
</style>



// WEBPACK FOOTER //
// position.vue?f118ecc6